var React = require('react');

function RoundInline (props) {
    return React.createElement("svg",props,React.createElement("rect",{"width":"738","height":"500","rx":"200"}));
}

RoundInline.defaultProps = {"width":"738","height":"500","viewBox":"0 0 738 500","fill":"none"};

module.exports = RoundInline;

RoundInline.default = RoundInline;
